import React, { useMemo } from 'react'

function nl2br (str) {
    if (typeof str === 'undefined' || str === null) {
        return ''
    }
    return (str + '').replace(/\n\s*\n/g, '<br />')
}

const Nl2br = props => {
    const children = useMemo(() => nl2br(props.children), [props.children])
    return <span dangerouslySetInnerHTML={{ __html: nl2br(children) }} />
}

export default Nl2br
